"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidClassLabelOrder = void 0;
const _ = __importStar(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
// Input set should be sorted by the caller
const isValidClassLabelOrder = (sortedClassLabels) => {
    // Validate input is sorted (clone to avoid mutation of original input)
    const clonedSortedInput = _.clone(sortedClassLabels).sort();
    if (!_.isEqual(sortedClassLabels, clonedSortedInput)) {
        return false;
    }
    // Get defined class label letters (A -> F)
    const validClassLabelLetters = Object.values(finley_types_1.CreditFacility.ClassLabel)
        .filter((label) => label.length === 1)
        .sort();
    // Construct class label map to hold labels that were found
    const classLabelMap = new Map(validClassLabelLetters.map((label) => [label, []]));
    // Letters must be used in order
    let currentLetterIndex = 0;
    for (const classLabel of sortedClassLabels) {
        // Get letter for label
        const classLabelLetter = classLabel.charAt(0);
        // Get number for label if provided, otherwise '' becomes 1
        const classLabelNumber = Number(classLabel.slice(1)) || 1;
        const classLabelNumbers = classLabelMap.get(classLabelLetter);
        // If not already set, the input label is an invalid letter
        if (!classLabelNumbers) {
            return false;
        }
        // Check letter
        if (validClassLabelLetters[currentLetterIndex] === classLabelLetter) {
            // Same letter, don't update index
            // no-op
        }
        else if (validClassLabelLetters[currentLetterIndex + 1] === classLabelLetter) {
            // Next letter, update index
            currentLetterIndex += 1;
        }
        else {
            // Letter does not match current or next letter, invalid sequence
            return false;
        }
        // At this point, letter was valid, now check number
        // Set number in array
        classLabelNumbers.push(classLabelNumber);
        // Validate numbers match expected sequence
        const arrayLength = classLabelNumbers.length;
        const expectedSequence = new Array(arrayLength)
            .fill(null)
            .map((_element, idx) => idx + 1);
        if (!_.isEqual(classLabelNumbers, expectedSequence)) {
            return false;
        }
    }
    return true;
};
exports.isValidClassLabelOrder = isValidClassLabelOrder;
//# sourceMappingURL=validation.js.map